var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetItOnGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "livetype",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 119.7 40"
    },
    viewBox: "0 0 119.7 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#fff;stroke:#fff;stroke-width:.2;stroke-miterlimit:10}.st8{opacity:.12;enable-background:new}")), /*#__PURE__*/React.createElement("path", {
    d: "M110.1 0H7.5c-.7 0-1.3.1-2 .2-.6.1-1.3.3-1.9.6C3 1.1 2.5 1.5 2 2S1.1 3 .8 3.6C.5 4.2.3 4.9.2 5.5c-.1.7-.2 1.4-.2 2v24.9c0 .7.1 1.3.2 2s.3 1.3.6 1.9c.3.7.7 1.2 1.2 1.7s1 .9 1.6 1.2c.6.3 1.2.5 1.9.6.7.1 1.3.2 2 .2h104.6c.7 0 1.3-.1 2-.2s1.3-.3 1.9-.6c.6-.3 1.1-.7 1.6-1.2s.9-1 1.2-1.6c.3-.6.5-1.2.6-1.9.1-.7.2-1.3.2-2v-25c0-.7-.1-1.3-.2-2s-.3-1.3-.6-1.9c-.6-1.2-1.6-2.2-2.8-2.8-.6-.3-1.2-.5-1.9-.6-.7-.1-1.3-.2-2-.2h-2z",
    style: {
      fill: "#a6a6a6"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 39.1h-.9c-.6 0-1.3-.1-1.9-.2-.6-.1-1.1-.3-1.7-.5-.5-.3-1-.6-1.4-1-.4-.4-.8-.9-1-1.4-.3-.5-.4-1.1-.5-1.7-.1-.6-.2-1.2-.2-1.9V7.5c0-.6.1-1.3.2-1.9.1-.5.3-1.1.6-1.6s.6-1 1-1.4c.4-.4.9-.7 1.4-1 .5-.3 1.1-.4 1.7-.5C6.3 1 6.9.9 7.6.9H112.2c.6 0 1.2.1 1.9.2.6.1 1.1.3 1.7.5 1 .5 1.9 1.4 2.4 2.4.3.5.4 1.1.5 1.6.1.6.2 1.3.2 1.9v24.9c0 .6-.1 1.2-.2 1.9-.1.6-.3 1.1-.5 1.7-.3.5-.6 1-1 1.4-.4.4-.9.8-1.4 1-.5.3-1.1.5-1.7.5-.6.1-1.2.2-1.9.2H8.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1 11.2c0 .7-.2 1.3-.7 1.8-.5.5-1.2.8-2 .8s-1.4-.3-2-.8c-.5-.5-.8-1.2-.8-2s.3-1.4.8-2c.5-.5 1.2-.8 2-.8.4 0 .7.1 1.1.2.3.1.6.3.8.6l-.5.5c-.4-.4-.8-.6-1.5-.6-.6 0-1 .2-1.5.6-.4.4-.6.9-.6 1.5s.2 1.1.6 1.5c.4.4.9.6 1.5.6s1.1-.2 1.5-.6c.3-.3.4-.6.4-1.1h-1.9v-.6H42c.1.1.1.2.1.4zM46.2 8.9h-2.4v1.7H46v.6h-2.2v1.7h2.4v.7h-3.1V8.3h3.1v.6zM49 13.6h-.7V8.9h-1.5v-.6h3.7V9H49v4.6zM53.2 13.6V8.3h.7v5.3h-.7zM56.9 13.6h-.7V8.9h-1.5v-.6h3.7V9h-1.5v4.6zM65.3 12.9c-.5.5-1.2.8-1.9.8-.8 0-1.4-.3-1.9-.8s-.8-1.2-.8-2 .3-1.4.8-2c.5-.5 1.2-.8 1.9-.8.8 0 1.4.3 1.9.8s.8 1.2.8 2-.3 1.5-.8 2zm-3.4-.4c.4.4.9.6 1.4.6s1.1-.2 1.4-.6c.4-.4.6-.9.6-1.5s-.2-1.1-.6-1.5c-.4-.4-.9-.6-1.4-.6s-1 .1-1.4.5c-.4.4-.6.9-.6 1.5s.2 1.2.6 1.6zM67 13.6V8.3h.8l2.6 4.1V8.3h.7v5.3h-.7l-2.7-4.3v4.3H67z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.4 21.3c-2.1 0-3.8 1.6-3.8 3.8 0 2.2 1.7 3.8 3.8 3.8 2.1 0 3.8-1.6 3.8-3.8 0-2.2-1.7-3.8-3.8-3.8zm0 6.1c-1.1 0-2.1-.9-2.1-2.3s1-2.3 2.1-2.3 2.1.9 2.1 2.3-.9 2.3-2.1 2.3zm-8.2-6.1c-2.1 0-3.8 1.6-3.8 3.8 0 2.2 1.7 3.8 3.8 3.8 2.1 0 3.8-1.6 3.8-3.8 0-2.2-1.7-3.8-3.8-3.8zm0 6.1c-1.1 0-2.1-.9-2.1-2.3s1-2.3 2.1-2.3 2.1.9 2.1 2.3-1 2.3-2.1 2.3zm-9.8-4.9v1.6h3.8c-.1.9-.4 1.6-.9 2-.6.6-1.4 1.2-3 1.2-2.4 0-4.2-1.9-4.2-4.3s1.8-4.3 4.2-4.3c1.3 0 2.2.5 2.9 1.1l1.1-1.1c-1-.9-2.2-1.6-4-1.6-3.2 0-5.9 2.6-5.9 5.9 0 3.2 2.7 5.9 5.9 5.9 1.7 0 3.1-.6 4.1-1.6 1.1-1.1 1.4-2.5 1.4-3.7 0-.4 0-.7-.1-1h-5.3zm40.1 1.2c-.3-.8-1.3-2.4-3.2-2.4-1.9 0-3.6 1.5-3.6 3.8 0 2.1 1.6 3.8 3.7 3.8 1.7 0 2.7-1.1 3.1-1.7l-1.3-.9c-.4.6-1 1-1.9 1-.8 0-1.4-.4-1.8-1.1l5-2.1v-.4zM77.4 25c0-1.5 1.1-2.2 2-2.2.7 0 1.2.3 1.4.8L77.4 25zm-4.1 3.7H75V17.6h-1.7v11.1zm-2.8-6.5c-.4-.4-1.1-.8-2-.8-1.9 0-3.6 1.7-3.6 3.8 0 2.1 1.7 3.8 3.6 3.8.9 0 1.6-.4 2-.9h.1v.5c0 1.4-.8 2.2-2 2.2-1 0-1.6-.7-1.9-1.3l-1.5.5c.4 1 1.5 2.2 3.3 2.2 1.9 0 3.6-1.1 3.6-3.9v-6.8h-1.6v.7zm-1.8 5.2c-1.1 0-2.1-1-2.1-2.3 0-1.3 1-2.3 2.1-2.3s2 1 2 2.3c0 1.3-.9 2.3-2 2.3zm21.5-9.8h-4v11.1h1.7v-4.2h2.3c1.8 0 3.6-1.3 3.6-3.4s-1.7-3.5-3.6-3.5zm.1 5.3h-2.4v-3.8h2.4c1.2 0 1.9 1 1.9 1.9 0 .9-.7 1.9-1.9 1.9zm10.2-1.6c-1.2 0-2.4.5-2.9 1.7l1.5.6c.3-.6.9-.8 1.5-.8.9 0 1.7.5 1.7 1.4v.1c-.3-.2-.9-.4-1.7-.4-1.6 0-3.2.9-3.2 2.5 0 1.5 1.3 2.4 2.7 2.4 1.1 0 1.7-.5 2.1-1.1h.1v.9h1.6v-4.2c0-2-1.5-3.1-3.4-3.1zm-.2 6.1c-.5 0-1.3-.3-1.3-.9 0-.9.9-1.2 1.8-1.2.7 0 1.1.2 1.5.4-.2 1-1 1.7-2 1.7zm9.4-5.8-1.9 4.8h-.1l-2-4.8H104l2.9 6.7-1.7 3.7h1.7l4.5-10.4h-1.7zm-14.9 7.1h1.7V17.6h-1.7v11.1z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 19.378,
    x2: 4.513,
    y1: 32.207,
    y2: 17.341,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00a0ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    style: {
      stopColor: "#00a1ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#00beff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    style: {
      stopColor: "#00d2ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#00dfff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00e3ff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 8.8c-.2.2-.4.7-.4 1.2v19.6c0 .5.2 1 .4 1.2l.1.1 11-11v-.2L9.3 8.8z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035512576740299148550000016547054239078941374_",
    x1: 30.038,
    x2: 8.605,
    y1: 22.205,
    y2: 22.205,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffe000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#ffbd00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    style: {
      stopColor: "orange"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff9c00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24 23.6-3.7-3.7v-.2L24 16h.1l4.3 2.5c1.2.7 1.2 1.9 0 2.6L24 23.6z",
    style: {
      fill: "url(#SVGID_00000035512576740299148550000016547054239078941374_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065053754407223488920000012996049420848987009_",
    x1: 22.06,
    x2: 1.901,
    y1: 20.172,
    y2: 0.013,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff3a44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c31162"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m24.1 23.5-3.7-3.7-11 11c.4.4 1.1.5 1.8.1l12.9-7.4",
    style: {
      fill: "url(#SVGID_00000065053754407223488920000012996049420848987009_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145017984560319074390000000324982644292237699_",
    x1: 6.532,
    x2: 15.534,
    y1: 39.766,
    y2: 30.764,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32a071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#2da771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    style: {
      stopColor: "#15cf74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    style: {
      stopColor: "#06e775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00f076"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.1 16.1 11.2 8.7c-.8-.4-1.4-.4-1.8.1l11 11 3.7-3.7z",
    style: {
      fill: "url(#SVGID_00000145017984560319074390000000324982644292237699_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 23.5-12.9 7.3c-.7.4-1.4.4-1.8 0l-.1.1.1.1c.4.4 1.1.4 1.8 0L24 23.5z",
    style: {
      opacity: 0.2,
      enableBackground: "new"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 30.7c-.3-.3-.4-.7-.4-1.2v.1c0 .5.2 1 .4 1.2v-.1zM28.4 20.9 24 23.5l.1.1 4.3-2.5c.6-.4.9-.8.9-1.3 0 .4-.3.8-.9 1.1z",
    className: "st8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11.2 8.8 17.3 9.8c.6.3.9.7.9 1.1 0-.5-.3-.9-.9-1.3L11.2 8.7C9.9 8 8.9 8.6 8.9 10v.1c0-1.4 1-2 2.3-1.3z",
    style: {
      opacity: 0.25,
      fill: "#fff",
      enableBackground: "new"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetItOnGooglePlay);
export default __webpack_public_path__ + "static/media/get-it-on-google-play.f1a78585632320637c03d16cfb6a79ce.svg";
export { ForwardRef as ReactComponent };